import React from "react";
import { InlinePickTrigger } from "../../atoms/InlinePickTrigger";
import { Dropdown } from "../Dropdown";
import type { DropdownProps } from "../Dropdown";

/** Menu floor in px: a narrow trigger ("5") still opens a readable list. */
const MIN_MENU_WIDTH = 160;

/** The props a sentence picker takes from `Dropdown`; the trigger and menu look are fixed here. */
export type InlinePickDropdownProps<V extends string> = Omit<DropdownProps<V>, "trigger" | "variant" | "fullWidth" | "hugTrigger" | "size" | "compact">;

/**
 * A `Dropdown` whose trigger is an `InlinePickTrigger`, for pickers set inside a sentence.
 * Same props as `Dropdown`; the open state and `triggerRef` still come from the caller.
 */
export function InlinePickDropdown<V extends string>(props: InlinePickDropdownProps<V>) {
  const { value, options, open, onToggle, triggerRef, ariaLabel, placeholder, invalid, disabled } = props;
  const selected = options.find((o) => o.value === value);
  return (
    <Dropdown
      {...props}
      variant="picker"
      fullWidth={false}
      hugTrigger
      minMenuWidth={props.minMenuWidth ?? MIN_MENU_WIDTH}
      trigger={
        <InlinePickTrigger
          ref={triggerRef}
          label={selected?.label ?? ""}
          placeholder={placeholder}
          open={Boolean(open)}
          invalid={invalid}
          disabled={disabled}
          ariaLabel={ariaLabel ?? ""}
          onClick={() => onToggle?.()}
        />
      }
    />
  );
}

export default InlinePickDropdown;
